module.exports = __webpack_public_path__ + "media/images/application/template/queens-innovation-2018-c4899e4c2061b45795e4ea319c18575b.svg";